// extracted by mini-css-extract-plugin
export default {"productGallery":"zE-z","inQuickShop":"AE-z"};